export class Alarm {
    Name: string = null;
    State: string = null;
    Description: string = null;
    StateUpdatedUtc: string = null;
    Autoscaling: boolean = false;
}

export enum AlarmType {
    OK = "complete-color",
    ALARM = "error-color"
}

export class AlarmsTripped {
    LatestStateUpdateUtc: string = null;
    Total: number = 0;
}
